// iframe-communication.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IframeCommunicationService {
  private iframeLogoutSubject = new Subject<void>();

  iframeLogout$ = this.iframeLogoutSubject.asObservable();

  triggerIframeLogout() {
    this.iframeLogoutSubject.next();
  }
}
